module.exports = __webpack_public_path__ + "img/user-14.00989f12.svg";